export default __webpack_public_path__ + "static/media/creditCard.013bc8c1.svg";